/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Attachment_RemoveInputs */



/**
* | output |
* | --- |
* | "Remove file" |
*
* @param {Chat_Attachment_RemoveInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const chat_attachment_remove = /** @type {((inputs?: Chat_Attachment_RemoveInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Attachment_RemoveInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Bestand verwijderen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Retirer le fichier")
	return /** @type {LocalizedString} */ ("Remove file")
});